import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../TripTrackingV2.module.scss';

const goBack = () => {
  history.back();
};

const TripHeader = ({ trip }) => (
  <div className={styles.header}>
    <div className={styles.headerTop}>
      <button type="button" className={styles.backButton} onClick={goBack} aria-label="Go back">
        <img src="/images/back.svg" alt="" />
      </button>
      <Link to={`/trip/${trip.tripId}`} className={styles.tripNo}>
        {`Trip - ${trip.doNo}`}
      </Link>
    </div>
    <div className={styles.badgeRow}>
      {trip.isAutoCreated && <span className={styles.badge}>Auto Created</span>}
      {trip.status && (
        <span className={`${styles.badge} ${styles.statusBadge}`} style={{ background: trip.status.code }}>
          {trip.status.text}
        </span>
      )}
      {[trip.serviceType, trip.boundType, trip.runType, trip.modeType].filter(Boolean).map((label) => (
        <span className={styles.badge} key={label}>{label}</span>
      ))}
    </div>
  </div>
);

export default TripHeader;
